import { API_BASE_URL, apiRequest } from "./api";
import type { TeenExperienceReportResponse } from "../types/teenExperienceReportTypes";

export const teenExperienceReportApi = {
  get(): Promise<TeenExperienceReportResponse> {
    return apiRequest<TeenExperienceReportResponse>("/api/teen/experience-report", {
      method: "GET",
    });
  },

  pdfUrl(): string {
    return `${API_BASE_URL}/api/teen/experience-report/pdf`;
  },
};
